import { useQuery, type UseQueryResult } from '@tanstack/react-query';

import { analyticsPath, apiClient } from '@/lib/api-client';
import { adaptPopularRegions, type ApiPopularRegionsResponse } from '@/lib/analytics-adapters';
import type { PopularRegions } from '@/types/analytics';

import { analyticsKeys } from './analytics-keys';

export function usePopularRegions(): UseQueryResult<PopularRegions, Error> {
  return useQuery({
    queryKey: analyticsKeys.popularRegions(),
    queryFn: async ({ signal }) =>
      adaptPopularRegions(
        await apiClient.get<ApiPopularRegionsResponse>(analyticsPath('/regions/popular'), signal),
      ),
    refetchInterval: 30_000,
  });
}
